<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div style="display: flex; justify-content: flex-end">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" v-bind="attrs" v-on="on">
                <v-icon>add_circle</v-icon>Add
              </v-btn>
            </template>
            <v-list>
              <v-list-tile @click="onRegister">
                <v-list-tile-content>
                  <v-list-tile-title>ADD NEW</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="success"
                :loading="buttonLoading"
                v-bind="attrs"
                v-on="on"
                ><v-icon>cloud_download</v-icon>Export</v-btn
              >
            </template>

            <v-list>
              <v-list-tile
                @click="printAccountTypeList('printAccountTypeList')"
              >
                <v-list-tile-content>
                  <v-list-tile-title>PRINT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile @click="exportAllAccountType()">
                <v-list-tile-content>
                  <v-list-tile-title>EXPORT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-btn @click="showFilters = !showFilters" color="#FF4545">
            <v-icon>filter_list</v-icon>Filter
            <v-icon>{{
              showFilters ? "arrow_drop_up" : "arrow_drop_down"
            }}</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 v-if="showFilters">
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm3>
              <v-text-field
                name="name"
                label="Name"
                type="text"
                v-model="queryParams.name"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="natureList"
                label="Nature"
                v-model="queryParams.nature"
                item-text="label"
                item-value="value"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="statusList"
                label="Status"
                v-model="queryParams.status"
                item-text="label"
                item-value="value"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :headers="headers"
            :items="accountTypeList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
            :must-sort="true"
          >
            <template slot="items" slot-scope="props">
              <td>
                <v-btn
                  flat
                  icon
                  color="blue lighten-2"
                  @click="onEdit(props.item)"
                >
                  <v-icon>edit</v-icon>
                </v-btn>
              </td>
              <td>
                <v-icon
                  v-if="props.item.status == 'ACTIVE'"
                  medium
                  color="green"
                  >check_circle</v-icon
                >
                <v-icon v-else medium color="red">cancel</v-icon>
              </td>
              <td>{{ props.item.code }}</td>
              <td>{{ props.item.accTypeName }}</td>
              <td>{{ props.item.accTypeNature }}</td>
              <td>
                {{
                  props.item.updatedDateInMilliSeconds
                    | format-ms-date-time
                }}
              </td>
              <td>{{ props.item.updatedBy }}</td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>

    <!--print all-->
    <div
      id="printAccountTypeList"
      style="border: 1px solid black; width: 300px"
      v-show="false"
    >
      <div style="text-align: center">
        <p style="font-size: 18px; margin: 1px">Account Type List</p>
      </div>
      <div style="padding-left: 5px; padding-right: 5px">
        <table
          style="
            font-family: arial, sans-serif;
            border-collapse: collapse;
            width: 100%;
            font-size: 11px;
          "
        >
          <thead
            style="border-bottom: 1px solid black; border-top: 1px solid black"
          >
            <tr>
              <th style="text-align: left">Code</th>
              <th style="text-align: left">Account Type Name</th>
              <th style="text-align: left">Account Type Nature</th>
              <th style="text-align: left">Updated Date</th>
              <th style="text-align: left">Updated By</th>
              <th style="text-align: left">Status</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in allAccountTypeList" :key="index">
              <td>{{ item.code }}</td>
              <td>{{ item.accTypeName }}</td>
              <td>{{ item.accTypeNature }}</td>
              <td>
                {{
                  item.updatedDateInMilliSeconds | format-ms-date-time
                }}
              </td>
              <td>{{ item.updatedBy }}</td>
              <td>{{ item.status }}</td>
            </tr>
          </tbody>
        </table>
        <div style="height: 10px"></div>
      </div>
    </div>
  </v-container>
</template>
<script>
import { accountTypeService } from "../../services/account-type-service";
import { commonService } from "../../services/common-service";

export default {
  name: "AccountTypeList",
  components: {},
  data: () => ({
    buttonLoading: false,
    showListLoading: false,
    showFilters: false,
    breadcrumbs: [
      {
        text: "Finance",
        disabled: true,
      },
      {
        text: "Account Type",
        disabled: true,
      },
    ],
    headers: [
      { text: "Action", value: "name", sortable: false },
      { text: "Status", value: "status" },
      { text: "Code", align: "left", value: "code" },
      { text: "Account Type Name", value: "accTypeName" },
      { text: "Account Type Nature", value: "accTypeNature" },
      { text: "Updated Date", value: "updatedDate" },
      { text: "Updated By", value: "updatedBy" },
    ],
    statusList: [
      { label: "All", value: "" },
      { label: "Active", value: "ACTIVE" },
      { label: "Inactive", value: "INACTIVE" },
    ],
    natureList: [
      { label: "All", value: "" },
      { label: "BS", value: "BS" },
      { label: "IS", value: "IS" },
    ],
    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "updatedDate",
      totalItems: 0,
    },
    accountTypeList: [],
    allAccountTypeList: [],
    totalRows: 0,
    queryParams: {
      name: "",
      nature: "",
      status: "",
    },
  }),
  watch: {
    pagination: {
      handler() {
        this.getAccountTypeList();
      },
      deep: true,
    },
  },
  created() {
    //for deep linking
    if (this.$route.query.name) {
      this.queryParams.name = this.$route.query.name;
    }
    if (this.$route.query.nature) {
      this.queryParams.nature = this.$route.query.nature;
    }
    if (this.$route.query.status) {
      this.queryParams.status = this.$route.query.status;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
  },
  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({ name: "account-types", query: this.queryParams });
      this.getAccountTypeList();
    },
    getAccountTypeList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      accountTypeService
        .getAccountTypeList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.accountTypeList = res.data.accountTypeList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    onRegister() {
      this.$router.push("/account-type/new");
    },
    onEdit(accountType) {
      // go to details page
      this.$router.push("/account-type/" + accountType.id);
    },
    exportAllAccountType() {
      this.buttonLoading = true;
      accountTypeService
        .getAccountTypeExcelExport(this.queryParams)
        .then((res) => {
          commonService.downloadE(res);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.buttonLoading = false;
        });
    },
    printAccountTypeList(divName) {
      this.buttonLoading = true;
      accountTypeService
        .getAllAccountTypeList(this.queryParams)
        .then((res) => {
          if (res.data) {
            this.allAccountTypeList = res.data.accountTypeList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          var printContents = document.getElementById(divName).innerHTML;
          var reprintWindow = window.open(
            "",
            "MsgWindow",
            "width=500,height=500"
          );
          reprintWindow.document.write(printContents);
          setTimeout(() => {
            reprintWindow.print();
            reprintWindow.close();
          }, 600);
          this.buttonLoading = false;
        });
    },
  },
};
</script>